"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Exports all API response types for typescript users

var buckets_pb_1 = require("@textile/buckets-grpc/buckets_pb");

Object.defineProperty(exports, "ArchiveInfoResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.ArchiveInfoResponse;
  }
});
Object.defineProperty(exports, "ArchiveResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.ArchiveResponse;
  }
});
Object.defineProperty(exports, "ArchiveStatusResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.ArchiveStatusResponse;
  }
});
Object.defineProperty(exports, "ArchiveWatchResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.ArchiveWatchResponse;
  }
});
Object.defineProperty(exports, "CreateResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.CreateResponse;
  }
});
Object.defineProperty(exports, "LinksResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.LinksResponse;
  }
});
Object.defineProperty(exports, "ListIpfsPathResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.ListIpfsPathResponse;
  }
});
Object.defineProperty(exports, "ListPathResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.ListPathResponse;
  }
});
Object.defineProperty(exports, "ListResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.ListResponse;
  }
});
Object.defineProperty(exports, "Metadata", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.Metadata;
  }
});
Object.defineProperty(exports, "PathItem", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.PathItem;
  }
});
Object.defineProperty(exports, "PullIpfsPathResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.PullIpfsPathResponse;
  }
});
Object.defineProperty(exports, "PullPathResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.PullPathResponse;
  }
});
Object.defineProperty(exports, "PushPathResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.PushPathResponse;
  }
});
Object.defineProperty(exports, "RemovePathResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.RemovePathResponse;
  }
});
Object.defineProperty(exports, "RemoveResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.RemoveResponse;
  }
});
Object.defineProperty(exports, "Root", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.Root;
  }
});
Object.defineProperty(exports, "RootResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.RootResponse;
  }
});
Object.defineProperty(exports, "SetPathResponse", {
  enumerable: true,
  get: function get() {
    return buckets_pb_1.SetPathResponse;
  }
});

__exportStar(require("./api"), exports);

__exportStar(require("./buckets"), exports);

__exportStar(require("./utils"), exports);